import { Navigate, useLocation } from "react-router-dom";

/** Client redirect that keeps ?query= and #hash (e.g. QR campaign ?source=). */
const RedirectWithSearch = ({ to }) => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
};

export default RedirectWithSearch;
